
import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* Pre Algebra 1e */ 'caa57dab-41c7-455e-bd6f-f443cda5519c': [
    /* Pre Algebra 2e */ ['f0fa90be-fca8-43c9-9aad-715c0a2cee2b', {
      /* Preface to the same module in 2e */
      '17639dba-bc07-45a2-8d8d-d1baa2a639b7' : '7ea0090a-b888-4600-9893-596127c769cc',
      /* 1.0 Introduction	to the same module in 2e */
      'a652edf4-562b-4629-a940-7fc35e8a3727' : '06a5799f-762d-4f1f-8603-b077f4284a43',
      /* 1.1  Introduction to Whole Numbers to the same module in 2e */
      '814cc21c-bc14-4384-acc3-1d7c638e217b' : '7cbc90c7-60c8-4211-bffe-b77aadc95509',
      /* 1.2  Add Whole Numbers	to the same module in 2e */
      '8eaf60c1-b5a8-40cd-b2b1-4eff95ff3ebe' : '8069044b-6fb1-49bf-b03a-64988f9b1ddd',
      /* 1.3  Subtract Whole Numbers to the same module in 2e */
      '4a52088b-8ce2-44aa-99a4-63b1c2805db4' : 'b7b437ef-73c1-446d-a42c-7a7ebe933114',
      /* 1.4  Multiply Whole Numbers to the same module in 2e */
      '06295da2-6c94-4e51-933f-e38a33b7098d' : '9b248006-6668-446c-bcc4-bd1a9730b4ad',
      /* 1.5  Divide Whole Numbers to the same module in 2e */
      '5adf7575-3192-4e18-9e0d-297a60911d05' : 'f7446efa-8302-4ef6-9e5a-bdc05acb3613',
      /* 2.0 Introduction	to the same module in 2e */
      'a83b585b-7b3c-456e-aab0-13ce4a13aa61' : 'fb1295cf-7c5d-482c-bffa-0b11a2815588',
      /* 2.1  Use the Language of Algebra to the same module in 2e */
      'e77e297e-3f3e-41a5-9bb9-20268db2661c' : 'c99ce701-d3cb-4b3d-9864-8a4861034a81',
      /* 2.2  Evaluate, Simplify and Translate Expressions to the same module in 2e */
      'a7c52de4-2b00-4050-8a7a-2a0dd3cd8660' : 'f8ffe655-ee35-4be9-9b1b-ae94f43c84fa',
      /* 2.3  Solve Equations with the Subtraction and Addition Properties of Equalityto the same module in 2e */
      'f5e12d30-a41a-4067-a246-2ad1a8cd662e' : 'f0e638b1-8ef3-4895-b033-18aa6d0d3564',
      /* 2.4  Find Multiples and Factors to the same module in 2e */
      '3632bfb6-e470-4a0c-934e-5f0c5c76931b' : 'f8af279f-9990-4610-b634-0ba844760dea',
      /* 2.5  Prime Factorization and the Least Common Multiple	to the same module in 2e */
      '050e33e4-8b38-4321-bf2d-3f34bd5f90ff' : 'f844b6a5-7d09-4876-b9dc-aa70a9d3a4af',
      /* 3.0 Introduction	to the same module in 2e */
      '36e3a45b-e220-43db-bc54-b7ae6e6f1806' : 'b1f6be62-7bd1-49d9-a940-f09bc3a0d697',
      /* 3.1  Introduction to  Integers	to the same module in 2e */
      '12309644-2f78-46df-aedd-71a0afb677a7' : 'ff579e3c-dd25-47d2-9e73-edfdee3ace70',
      /* 3.2  Add Integers	to the same module in 2e */
      '78036eed-e88b-45dd-bb54-8e29403ea5cb' : '8a49b727-d592-4930-8e54-9b30c1eba914',
      /* 3.3  Subtract Integers	to the same module in 2e */
      'b65fa044-bfc4-4e81-baf6-67bab718489e' : '834642be-f141-48c4-aa97-01b61193ccd0',
      /* 3.4  Multiply and Divide Integers to the same module in 2e */
      '2d4516ed-adf6-42f9-8e9a-9a47b4258366' : '25c4a027-b875-440c-bd4d-5151ed2001bd',
      /* 3.5  Solve Equations Using Integers; The Division Property of Equality	to the same module in 2e */
      '15d4e873-f501-4b05-82d5-11a567827ef4': '4208f187-08ad-402a-b95f-0a9a46582e52',
      /* 4.0 Introduction	to the same module in 2e */
      '8705c3fc-689d-4868-99fd-c2b12e794388': '2c443b68-89c8-4b23-bf31-6d1b621c4536',
      /* 4.1  Visualize Fractions	to the same module in 2e */
      'fe83677e-2580-44b5-8505-7ee2260a988d': 'db65f95b-f29e-48d5-9a56-2ae1e16096b3',
      /* 4.2  Multiply and Divide Fractions	to the same module in 2e */
      'b3b92ee9-65f9-481a-9c54-81a50fd5c901': 'c4bc8665-2053-46a2-b4c6-da5277d1f63e',
      /* 4.3  Multiply and Divide Mixed Numbers and Complex Fractions	to the same module in 2e */
      'c6ee405c-d1b5-4aec-bb6f-ba8e5103bf62': 'f55bcfae-239c-4e6b-8ada-676f4f2be135',
      /* 4.4  Add and Subtract Fractions with Common Denominators	to the same module in 2e */
      '3cc25981-8e85-4195-b438-8332e5376edf': '0cc49fc3-6864-45e9-b662-aa664b962380',
      /* 4.5  Add and Subtract Fractions with Different Denominators	to the same module in 2e */
      'ea386be2-42c0-4669-8f70-bce48dba9d43': '585a56d9-e90a-42c5-a00b-8d275fddd81a',
      /* 4.6  Add and Subtract Mixed Numbers	to the same module in 2e */
      '6149a49f-3a7d-4fc2-a940-9b303cb3f4c9': 'a5956e79-3c5d-45b3-a564-4de0a2ded1ae',
      /* 4.7 Solve Equations with Fractions	to the same module in 2e */
      '96d18a1b-3b21-4fbf-8d2c-eaf9836e660c': '4a8e9b99-d40c-43c4-a97b-5c3be9cd8750',
      /* 5.0 Introduction	to the same module in 2e */
      '8b20716b-c67e-411a-8029-f07761bef0fc': '1fb0ecf9-35b2-44bf-bbb0-0e6d29172840',
      /* 5.1 Decimals	to the same module in 2e */
      '98fa704c-a8b3-46a9-82a1-70a6c9ba284b': 'b6e1863d-155b-4580-9d11-bb0d46db2d09',
      /* 5.2 Decimal Operations 	to the same module in 2e */
      'd0bee1a7-254a-4f06-83ce-949c9ea905dc': '47846d7d-94ab-47d7-965d-e95f964f2c1c',
      /* 5.3 Decimals and Fractions	to the same module in 2e */
      '880c2243-cdea-4d51-a52d-7192a2d536d0': '69f66012-2d0d-4978-87c5-e6a4b16a8ec5',
      /* 5.4 Solve Equations with Decimals	to the same module in 2e */
      'd914b268-4767-49bc-9586-cdd7bcae3dd3': '9fe35e21-25d0-4ce5-9906-fb7f3d5a05b4',
      /* 5.5 Averages and Probability to the same module in 2e */
      '3c61c759-aa7b-4fc0-9f45-f45c25b5b9fb': '21321804-a5f3-4577-b645-2ca735a977e6',
      /* 5.6 Ratios and Rates	to the same module in 2e */
      '50a6a030-22a0-4ed3-8928-b31d7a3b541c': 'c5568dd1-af4e-473d-a0ff-4b7e61e2db69',
      /* 5.7 Simplify and Use Square Rootsto the same module in 2e */
      'bebca386-26b6-4f6f-ac4a-0aa673939239': '36b90a09-411d-42af-8c04-3eaed7cb80ad',
      /* 6.0 Introduction	to the same module in 2e */
      '10b23aaf-8377-4406-bf84-c06058a251cc': '2e65c926-1d1b-4a52-918c-4b2175f14690',
      /* 6.1  Understand Percentto the same module in 2e */
      '88838c69-eff9-415b-bf37-7a302a07da95': '92ed48c0-32af-47e2-8a49-646d9cef3d43',
      /* 6.2  Solve General Applications of Percent	to the same module in 2e */
      '7f5c4e64-6bd2-4215-9d77-21578d65b83a': '933d1696-1e72-4093-a602-d7247a7ccd4b',
      /* 6.3  Solve Sales Tax, Commission, and Discount Applicationsto the same module in 2e */
      '151b5c8e-3eb8-46fd-84c5-5318081bdc48': 'ef33e13e-d5e8-4fe6-b40e-9caa62308c97',
      /* 6.4  Solve Simple Interest Applications	to the same module in 2e */
      'a6502754-731c-4334-bb9a-d3d27785e5e3': '4f3eed88-8d09-4c87-94c9-0bb7f4914ecb',
      /* 6.5  Solve Proportions and Their Applications	to the same module in 2e */
      '335afa4e-ae11-43f6-aaf7-46880b0acd80': '202c212c-f1f5-467e-b7e7-cf6fde5172da',
      /* 7.0 Introduction	to the same module in 2e */
      '1513e956-2332-439f-9a48-a4b8fd214cac': '97fa3f5c-578b-4d91-b2a4-12f43719b1a8',
      /* 7.1  Rational and Irrational Numbers	to the same module in 2e */
      'e975afa7-7b73-4718-9225-d8f2e382d2c0': '7ee5301b-3610-47e1-adfa-4ce2ca107c65',
      /* 7.2  Commutative and Associative Properties	to the same module in 2e */
      '9e6536b3-e083-49f4-891a-c05eb0543a1a': '60473ca2-c628-4e39-ac2e-1383385ffd82',
      /* 7.3  Distributive Property	to the same module in 2e */
      'ea427967-9ec1-4eeb-b6f8-a464ad68d602': '8f5f6a48-fd5c-4841-aeeb-5becb3a76af3',
      /* 7.4  Properties of Identities, Inverses, and Zero	to the same module in 2e */
      '20ea8443-492d-4284-9b64-0a1cdbc1f1f6': 'a3623f10-7b01-4b05-9e07-7c2a2a4acdab',
      /* 7.5 Systems of Measurement	to the same module in 2e */
      '66dd808e-3442-46d0-956d-9b9eb8ca0cc2': 'b02cd091-9e2c-47b1-bad6-680868b4ee8e',
      /* 8.0 Introduction	to the same module in 2e */
      '8cad294d-9c0c-413c-94ca-3eb658500799': '200deaa1-ff02-40e4-acae-5b045668e591',
      /* 8.1  Solve Equations using the Subtraction and Addition Properties of Equality	to the same module in 2e */
      'e9eff599-1142-4706-b131-fa8167a26e8e': '5a8cc4b8-4470-4e4b-b761-1929108174f2',
      /* 8.2  Solve Equations using the Division and Multiplication Properties of Equality	to the same module in 2e */
      '9f3a7546-566e-400d-9472-fafaf709a1ec': 'ca5d73eb-f188-4ddd-80f5-0d103e6df72a',
      /* 8.3  Solve Equations with Variables and Constants on Both Sides	to the same module in 2e */
      '718d778a-f2c5-4703-96fa-be9d2628fcf5': '4a268d92-837b-49cb-a6f2-0443ec1e2fc1',
      /* 8.4  Solve Equations with Fraction or Decimal Coefficients	to the same module in 2e */
      '3e5b9352-307f-4ba0-95a4-a4b074bab2de': 'd51d46b8-c1fb-4ae3-a369-ea31209c9ca3',
      /* 9.0 Introduction	to the same module in 2e */
      '7e2633ba-ff33-4114-9e53-6510a5aae69f': '792284df-979e-4ce1-8d64-7754afa9452a',
      /* 9.1  Use a Problem Solving Strategy	to the same module in 2e */
      '5062b88a-7002-4802-a381-3143f6250260': '940a8a74-fec1-49bd-ad9a-29e6b18b1dbd',
      /* 9.2  Solve Money Applications	to the same module in 2e */
      'd1d3f7ed-7231-427f-a5b5-4a879c5f7522': '6470a04b-f9f6-4d07-82ab-2b5302c984f4',
      /* 9.3  Use Properties of Angles, Triangles, and the Pythagorean Theorem	to the same module in 2e */
      'e00e083e-1ed1-4b3d-a582-e7ed0bffb478': '4c0177e5-a020-44df-8147-f6599ea62f38',
      /* 9.4  Use Properties of Rectangles, Triangles and Trapezoids	to the same module in 2e */
      '1e931ac3-1f77-4c51-bc46-7cdab095cc0e': 'f155553e-17fe-4c7d-9a66-ae70916e8320',
      /* 9.5  Solve Geometry Applications: Circles and Irregular Figures	to the same module in 2e */
      '6ca1dae8-06f8-490b-a22b-4182fccb62de': '16ede361-4729-4071-a37c-c5e5c28ed352',
      /* 9.6  Solve Geometry Applications: Volume and Surface Area 	to the same module in 2e */
      '08cbf757-50f1-4802-bd77-69241803d394': '39537675-6d2a-48bb-9917-7a43d2c116fc',
      /* 9.7  Solve a Formula for a Specific Variable	to the same module in 2e */
      '23002c49-7b21-4a10-912b-3f225bd12a87': 'fdecc523-30c3-46a7-a168-c24302d65420',
      /* 10.0 Introduction	to the same module in 2e */
      '35e1c0f1-86b4-49df-902a-25f0e57e267c': 'e933a12f-e1c9-4778-b0cc-8d92012427c7',
      /* 10.1  Add and Subtract Polynomials	to the same module in 2e */
      '31d9fc9e-aa3b-4506-ad7a-5559ba9e8c87': '7ebb5485-ff7f-4df5-8028-12ab4eabdb82',
      /* 10.2  Use Multiplication Properties of Exponents	to the same module in 2e */
      '35885848-bff3-4eaf-8d84-a24a5b600ada': '1ed2d0c6-4b2c-496f-8e97-236eab9dafe0',
      /* 10.3  Multiply Polynomials	to the same module in 2e */
      '5f7797c1-1f9b-465f-8a75-68d07c130cb0': '6eddcee7-b953-46db-92b4-db3be81acaed',
      /* 10.4  Divide Monomials	to the same module in 2e */
      'ab32d046-a37d-4c2d-b53d-8aa60567a376': 'f1ad5ff7-3a6e-415c-83c7-abf85ee94df7',
      /* 10.5 Integer Exponents and Scientific Notation	to the same module in 2e */
      '5353f649-58aa-4f94-a93a-1e3b109780fa': 'd741bac6-bd7f-4e82-9df0-bd1e094380b9',
      /* 10.6  Introduction to Factoring Polynomials	to the same module in 2e */
      'b56d8daf-3972-4841-8a74-157d42878971': '29daf534-a9bb-4e3e-90d2-065c7cdf9027',
      /* 11.0 Introduction	to the same module in 2e */
      '1bff7ad1-8794-4817-a5cd-a36145aadb73': 'b264a858-7da4-45c8-899c-8621a5d86185',
      /* 11.1 Use the Rectangular Coordinate System	to the same module in 2e */
      '2ef6a183-6937-40b4-80ef-b812bdff1abe': '85af0e19-a6a3-4e81-829c-b318c58f5d05',
      /* 11.2 Graph Linear Equations in Two Variables 	to the same module in 2e */
      '8f531bb1-2f5b-4c23-9d8c-96ec7c45f119': '20c6b413-f48a-4d3a-8adc-aef6f6e762d7',
      /* 11.3 Graph with Intercepts	to the same module in 2e */
      '41981d8b-35b2-4693-809d-24768d13803e': '1a6e2f8c-0399-4192-91b9-bcb8064aeee2',
      /* 11.4 Understand Slope of a Line	to the same module in 2e */
      'cdff4386-5dd5-48f8-9679-b31a0824b1a1': 'ea72caf9-e266-4a3a-870d-1a97e08b2881',
    }],
  ],
} as CanonicalBookMap;
